<template>
  <div class="card">
    <div>
      <h3>如何获取ticket</h3>
      <p>1、用账号在平台上登录（如果是调试对接，请在测试平台用测试账号登陆。如果已正式上线，请在正式平台用正式账号登陆）</p>
      <table class="account_table">
        <tr>
          <td>测试平台</td>
          <td></td>
        </tr>
        <tr>
          <td>测试账号</td>
          <td></td>
        </tr>
        <tr>
          <td>正式平台</td>
          <td></td>
        </tr>
        <tr>
          <td>正式账号</td>
          <td></td>
        </tr>
      </table>
      <p>2、找到对接实验课程，进入课程详情页面，点击“我要做实验”按钮</p>
      <img src="../../../assets/images/dev/get_ticket_1.png">
      <p>3、会弹出具体实验课程的跳转URL，Ticket会以参数形式提供，附在跳转URL后面。</p>
      <p>链接组成样例：实验平台的URL?ticket=TICKET, 例如：https://www.xxx.com/?ticket=3d337d7bcf3e85b85e8adeac36d21********************************************8dc7e3f84db3db7d2ce</p>
      <div style="margin-bottom: 50px;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GetTicket'
}
</script>

<style scoped>
.card {
  border: 1px solid #eee;
  padding: 20px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.card div img {
  width: 100%;
  max-width: 1200px;
}

p {
  word-wrap: break-word;
  word-break: break-all;
}

a {
  word-wrap: break-word;
  word-break: break-all;
}

div {
  word-wrap: break-word;
  word-break: break-all;
}

.account_table {
  width: 100%;
  max-width: 1200px;
  border: 1px solid #aaa;
  box-sizing: border-box;
}

.account_table tr td {
  border: 1px solid #aaa;
  padding: 5px;
}

.account_table tr td:first-child {
  width: 150px;
  background-color: #ddd;
  text-align: center;
}

h3,
h4,
h5 {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
